module.exports = __webpack_public_path__ + "669bf9d2cf12f20c024b02640dcc50c1.png";